/**
 * Standard Text Block JavaScript
 */

import { isBlockOnPage } from "../../src/js/modules/block-present.js";

(function() {
    'use strict';

    if (!isBlockOnPage("standard-text")) {
        return;
    }
})();